import { render, staticRenderFns } from "./RulesTable.vue?vue&type=template&id=365e133c&scoped=true&"
import script from "./RulesTable.vue?vue&type=script&lang=js&"
export * from "./RulesTable.vue?vue&type=script&lang=js&"
import style0 from "./RulesTable.vue?vue&type=style&index=0&id=365e133c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e133c",
  null
  
)

export default component.exports